import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Button, Col, Row } from 'components';
import { Api, theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const options = {
  style: {
    base: {
      iconColor: theme.SECONDARY,
      fontWeight: 500,
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#aaa'
      },
      '::placeholder': {
        color: '#aaa'
      }
    },
    invalid: {
      iconColor: 'red',
      color: 'red'
    }
  }
};

const stripe = loadStripe(process.env.REACT_APP_STRIPE_PK);

const CardInput = ({ closeModal, submit, loading, setLoading }) => {
  const stripe = useStripe(),
    elements = useElements(),
    { t } = useTranslation(),
    navigate = useNavigate(),
    dispatch = useDispatch(),
    location = useLocation();

  // Get the query parameter from the URL
  const queryParams = new URLSearchParams(location.search);
  const athleteId = queryParams.get('athleteId'); // Extract athleteId from query params
  const cta = queryParams.get('cta');
  const athleteName = queryParams.get('athleteName');

  const handleSubmit = async () => {
    setLoading(true);
    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement
    });

    if (error) {
      dispatch({
        type: 'HANDLE_RES',
        payload: { err: error.message }
      });

      setLoading(false);
      return console.log('[error]', error);
    }

    const { token } = await stripe.createToken(cardElement);
    const { card, id } = paymentMethod;
    const data = {
      exp: `${card.exp_month}/${card.exp_year}`,
      last4: card.last4,
      cardId: id,
      token: token.id
    };

    const res = await Api.post('/billing/addCard', data);
    if (!res) return;
    setLoading(false);
    closeModal();

    if (athleteId && (cta === 'requestShoutout' || cta === 'sendShoutout')) {
      navigate(`/profile/${athleteName}/${cta}?isPaymentRequired=false`);
    } else if (athleteId && cta === 'subscribe') {
      navigate(`/subscribe/${athleteId}`);
    } else if (cta) {
      window.open('/get-the-mobile-app', '_blank');
    }
  };

  return (
    <React.Fragment>
      <CardElement options={options} />

      <Col wid="100%" marg="40px 0 0">
        <Row noFlex>
          <Button big marg="0 8px 0 0" text={t('common.done')} onClick={handleSubmit} />

          <Button big bordered text={t('common.cancel')} onClick={!loading && closeModal} />
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default CardInput;
